import * as angular from 'angular';
import { AppStore } from '~/types/main.types';
import { ParameterOptions, ReportTypes } from '@mode/shared/contract-common';
import { ReportParametersController } from './report-parameters-component';
import { MixableBaseController } from '~/common/component';

/* eslint-disable @typescript-eslint/no-explicit-any */
class ReportParameterFieldController extends MixableBaseController {
  static $inject = ['RxStoreService'];
  private field: ReportTypes.ReportRunFormField;
  private isDisabled: boolean;
  private defaultOptions: ParameterOptions[] = [];
  private parent: ReportParametersController;

  constructor(private rxStoreService: AppStore) {
    super();
  }

  paramHelperFind(needle, haystack) {
    if (!angular.isArray(haystack)) {
      return needle == haystack;
    }
    for (let i = 0; i < haystack.length; i++) {
      if (haystack[i] == needle) {
        return true;
      }
    }
    return false;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes['field']) {
      this.initializedSelect();
    }
  }

  private initializedSelect() {
    if (this.field.type === 'multiselect' || this.field.type === 'select') {
      this.defaultOptions = [];
      let selectedOptions = [];
      const isMultiselectAllByDefault =
        this.field.type === 'multiselect' ? this.field.value?.length > 0 && this.field?.value[0] === 'all' : false;

      this.defaultOptions = this.field.options.map(([label, value]) => {
        const isSelected = isMultiselectAllByDefault || this.getIsSelected(this.field?.value, value);
        const defaultOption = {
          isSelected,
          label,
          value,
        };
        if (!this.isDisabled && isSelected) {
          selectedOptions = [...selectedOptions, defaultOption];
        }
        return defaultOption;
      });

      this.selectOptionChanged(
        selectedOptions.map((o) => [o.value, true]),
        this.field.type === 'select'
      );
    }
  }

  private getIsSelected(fieldVal, val) {
    //test if not an array
    //is not an array for select type, is for multiselect type
    const fieldValAsArray = !Array.isArray(fieldVal) ? [fieldVal] : fieldVal;
    return fieldValAsArray.some((x) => x == `${val}`);
  }

  selectOptionChanged(changes: [string | number, boolean][], isSingleSearch = false) {
    this.parent.updateFormParameters(changes, this.field.name, isSingleSearch);
  }

  isSelected(option) {
    // Convert string true/false to boolean if needed
    const currentVal =
      this.field.value === 'true' || this.field.value === 'false' ? JSON.parse(this.field.value) : this.field.value;
    return currentVal == option;
  }
}

const reportParameterFieldComponent: angular.IComponentOptions = {
  bindings: {
    field: '<',
    isDisabled: '<?',
  },
  require: {
    parent: '^reportParameters',
  },
  controller: ReportParameterFieldController,
  template: `
<div class="label-container">
  <i ng-if="ctrl.field.description" class="icon-info" uib-tooltip="{{ ctrl.field.description }}" tooltip-placement="bottom" tooltip-append-to-body="true" tooltip-class="wrapping-tooltip"></i>
  <label for="report_run_params_{{ ctrl.field.name }}" class="control-label" title="{{ ctrl.field.human_name }}">
    {{ ctrl.field.label }}
  </label>
  <capra-icon icon="icon-warning" class="align-md-icon warning" ng-if="ctrl.field.options_error" uib-tooltip="{{ ctrl.field.options_error.message }}"
    tooltip-placement="bottom" tooltip-append-to-body="true" tooltip-class="wrapping-tooltip"></capra-icon>
</div>

<mode-select-with-search
  ng-if="!ctrl.isDisabled && !ctrl.field.options_error && (ctrl.field.type == 'select' || ctrl.field.type == 'multiselect')"
  [field-type]="ctrl.field.type"
  [default-options]="ctrl.defaultOptions"
  (selected-option-changed)="ctrl.selectOptionChanged($event, ctrl.field.type == 'select')">
</mode-select-with-search>

<input type="text" ng-if="ctrl.field.type == 'text' || ctrl.isDisabled || ctrl.field.options_error"
  ng-disabled="ctrl.isDisabled || ctrl.field.options_error"
  id="report_run_params_{{ ctrl.field.name }}"
  name="report_run[params[{{ ctrl.field.name }}]]" value="{{ ctrl.field.options_error ? '' : ctrl.field.value }}"
  class="form-control form-control-sm next-form-control light-form form-control-block" />

<input type="text" mode-date-picker="{{ ctrl.field.value }}"
  ng-if="ctrl.field.type == 'date' && !ctrl.isDisabled"
  id="report_run_params_{{ ctrl.field.name }}"
  name="report_run[params[{{ ctrl.field.name }}]]"
  class="form-control form-control-sm next-form-control light-form form-control-block"
  show-icon="true" />
  `,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('reportParameterField', reportParameterFieldComponent);
